// @ts-nocheck
import { CountryModel } from "@insite/client-framework/Types/ApiModels";

const getPostalCodeConstantsKey = (country: CountryModel | null | undefined | string) => {
    const countryAbbreviation = typeof country === "string" ? country : country?.abbreviation;

    return countryAbbreviation === "US" ? "zipCode" : "postalCode";
};

export default getPostalCodeConstantsKey;
